import axios from 'axios';

export default {
  detail(id: string | number, params = {}) {
    return axios.get(`/users/admin/${id}`, {params});
  },
  update(id: string | number, payload = {}) {
    return axios.put(`/users/admin/${id}`, payload);
  },
};
